import { Action, ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store'
import { HubConnectionState } from '@microsoft/signalr'
import { storeFreeze } from 'ngrx-store-freeze'
import { localStorageSync } from 'ngrx-store-localstorage'

import { appReducers, AppState, initialAppState } from '../app.state'
import * as Auth from '../../shared/auth/store/actions/auth.actions'

import { environment } from '../../../environments/environment'

export const reducers: ActionReducerMap<AppState> = appReducers

/*
  preserved states' keys
 */
export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({keys: ['auth', 'user'], rehydrate: true})(reducer)
}

/*
  logout cleanup
 */
export function logout(reducer) {
  return function (state, action) {
    if (action.type !== Auth.LOGOUT_SUCCESS) {
      return reducer(state, action)
    }

    // reset state
    const initState: AppState = {
      ...initialAppState,
      signal: {
        ...initialAppState.signal,
        status: HubConnectionState.Disconnected
      }
    }
    return reducer(initState, action)
  }
}

/*
  store freeze dev helper - not working
 */
export function freezer(reducer: ActionReducer<any>): ActionReducer<any> {
  const exclusions: RegExp[] = [
    /^ROUTER_/,
    /Chat/,
    /Signal/,
    /Response/,
    /App/,
    /Team/
  ]

  return function (state: any, action: Action): any {
    const excluded = exclusions.reduce((current, next) => {
      const isExcluded = Boolean(action.type.match(next))

      return current || isExcluded
    }, false)

    if (excluded || environment.production) {
      return reducer(state, action)
    }

    return storeFreeze(reducer)(state, action)
  }
}

export const metaReducers: Array<MetaReducer<AppState>> = [
  // freezer,
  logout,
  localStorageSyncReducer,
]



// WEBPACK FOOTER //
// ./src/app/store/reducers/app.reducers.ts